import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';
import type { TwoFactorResponse } from 'src/features/login/components/two-factor-form/two-factor-form.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    twoFactor: builder.mutation<ApiResponse<TwoFactorResponse>, string>({
      query: (otp) => ({
        url: '/auth/verify-otp',
        method: 'GET',
        params: {
          otp,
        },
      }),
    }),
    verifyRecoveryCode: builder.mutation<ApiResponse<TwoFactorResponse>, string>({
      query: (code) => ({
        url: '/auth/recovery-codes/verify',
        method: 'GET',
        params: {
          code,
        },
      }),
    }),
  }),
});

export const { useTwoFactorMutation, useVerifyRecoveryCodeMutation } = extendedApiSlice;
